export default __webpack_public_path__ + "static/media/portfolio-small.b1ac9b5f.PNG";